import plModel from '../models/payload'

export function reportHasErrored(state = false, action) {
    switch (action.type) {
        case 'REPORT_HAS_ERRORED':
            return action.hasErrored

        default:
            return state
    }
}

export function reportIsLoading(state = false, action) {
    switch (action.type) {
        case 'REPORT_IS_LOADING':
            return action.isLoading

        default:
            return state
    }
}

export function builderReports(state = [], action) {
    switch(action.type) {
        case 'REPORT_FETCH_DATA_SUCCESS':
            return action.builderReports

        default:
            return state
    }
}

// This takes in dates and returns all the sales, cancels, closings, etc.
export function payload(state = plModel, action) {
    switch(action.type) {
        case 'FETCH_PAYLOAD_SUCCESS':
            return action.payload.data
        default:
            return state
    }
}

export function payloadStatus(state = false, action) {
    switch(action.type) {
        case 'UPDATE_PAYLOAD_STATUS':
            return action.payload
        default: 
            return state
    }
}